// accept integer for past days count
export const dateStringFormForFilter = (pastDay) => {
  const thatDay = new Date();
  thatDay.setDate(thatDay.getDate() - pastDay);
  let dateMonth = thatDay.getMonth() + 1; 
  let dateDate = thatDay.getDate();
  const dateYear = thatDay.getFullYear();
  if (dateDate < 10) dateDate = '0' + dateDate;
  if (dateMonth < 10) dateMonth = '0' + dateMonth;
  const formattedDate = dateMonth + '/' + dateDate + '/' + dateYear;
  // return date string with format mm/dd/yyyy
  return `${formattedDate}`;
};

